<template>
    <!-- 改用本地变量 localVisible 绑定 v-model -->
    <el-dialog :title="title" v-model="localVisible" width="80%" append-to-body @close="handleClose">
        <img :src="imageUrl" style="width: 100%;" alt="预览图片" />
    </el-dialog>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        imageUrl: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: '图片预览'
        }
    },
    data() {
        return {
            // 定义本地变量，初始值同步 props 的 visible
            localVisible: this.visible
        };
    },
    // 监听 props 变化，同步到本地变量（父组件修改 visible 时生效）
    watch: {
        visible(newVal) {
            this.localVisible = newVal;
        }
    },
    methods: {
        handleClose() {
            // 关闭时先更新本地变量，再通知父组件
            this.localVisible = false;
            this.$emit('close');
        }
    }
};
</script>

<style scoped></style>